<template>
  <div class="info-end" :style="{ '--bg': bg }">
    <img :src="`${cdnresources}/prod/images/xiangaibao/pageEnd1.png`">
    <div class="img2">
      <img :src="`${cdnresources}/prod/images/xiangaibao/pageEnd3.png`">
    </div>
    <div class="img3">
      <img :src="`${cdnresources}/prod/images/xiangaibao/wxCode.png`">
      <p>更多精彩内容<br />关注湖南爱民保公众号</p>
    </div>
    <div class="img4" @click="toCenter()" v-if="isPayShow">
      <img :src="`${cdnresources}/prod/images/xiangaibao/pageEnd4.png`">
    </div>
  </div>
</template>

<script>
import { cdnresources } from '@/util/config'
import { getDeviceInfo, gethttpurl } from '@/util/tools'

export default {
  name: 'PageEnd',

  components: {},

  filters: {},

  mixins: [],

  props: {},

  data() {
    return {
      cdnresources,
      isPayShow: true,
      bg: `url(${cdnresources}/prod/images/xiangaibao/pageEnd2.png) no-repeat`
    }
  },

  computed: {

  },

  watch: {},

  created() {

  },

  mounted() {
    let code = gethttpurl('fromSourceCode')
    let codeArr = ['yxhb00000315']
    if (codeArr.includes(code)) {
      this.$router.push({ path: '/404', query: { status: true } })
    } else {
      const DeviceInfo = getDeviceInfo()
      if (DeviceInfo.env === 'wechat') {
        this.isPayShow = true
      } else {
        this.isPayShow = false
      }
    }
  },

  destroyed() {
  },

  methods: {
    toCenter() {
      this.$router.push({
        path: `/user-center`
      })
    }
  }
}
</script>

<style scoped lang="less">
.info-end {
  width: 100%;
  height: 103vh;
  background: var(--bg);
  background-position: bottom center;
  box-sizing: border-box;

  img {
    width: 100%;
  }

  .img2 {
    width: 80%;
    margin: auto;
  }

  .img3 {
    width: 53%;
    margin: 30px auto 0;
    text-align: center;

    img {
      display: inline-block;
      width: 121px;
      height: 121px;
    }

    p {
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 22px;
    }
  }

  .img4 {
    position: fixed;
    bottom: 15%;
    right: 0;
    width: 12%;
  }
}
</style>
